<div class="box">
  <div class="box-row header">
    <app-header-bar
      [backRoute]="'/workflows'"
      [title]="workflow?.name || ('workflow.title' | translate)"
      [autoTranslateTitle]="false"
    ></app-header-bar>
  </div>
  <app-loading-indicator [loading]="isLoading"></app-loading-indicator>
  @if (workflow) {
    <div class="ml-4 mr-4 mb-2 mt-2">
      @if (canWriteWorkflows) {
        <button class="btn btn-nav float-end ms-3" (click)="edit()">
          <span class="material-symbols-outlined me-1">edit</span>
          {{ 'edit' | translate }}
        </button>
        <button class="btn btn-nav float-end ms-3" (click)="showDefinition()">
          <span class="material-symbols-outlined me-1">rebase</span>
          {{ 'workflow.definition' | translate }}
        </button>
      }
      <div class="clearfix"></div>
    </div>

    <div class="card">
      <div class="row">
        <div class="col-12">
          <h6 class="fw-bold">{{ 'workflow.description' | translate }}</h6>
          <p>{{ workflow.description }}</p>
        </div>
        @if (fileUrl) {
          <div class="col-12">
            <h6 class="fw-bold">{{ 'workflow.image' | translate }}</h6>
            <img
              src="{{ fileUrl }}"
              alt="{{ 'workflow.image' | translate }}"
              class="img-fluid"
            />
            <p class="text-muted" style="font-size: 0.75rem">
              {{ 'workflow.image_may_differ' | translate }}
            </p>
          </div>
        }
      </div>
    </div>
  }
  <app-error [error]="error"></app-error>
  <app-model-modal #EditModal (saveEvent)="onSave()">
    <app-workflow-form #form></app-workflow-form>
  </app-model-modal>
</div>
